import * as React from "react";
import { useState, useContext, useMemo } from "react";
import MessageDetailsContext from "./MessageDetailsContext";
import ListStateContext from "./ListStateContext";
const findMessageCallback = (activeMessageDetailsState) => (message) => activeMessageDetailsState && message.frontendId === activeMessageDetailsState.frontendId && message.index === activeMessageDetailsState.glIndex;
const _nextMessageDetails = (visibleMessages, setActiveMessageDetailsState, activeMessageDetailsState) => {
  const index = visibleMessages.findIndex(findMessageCallback(activeMessageDetailsState));
  if (index >= 0 && index < visibleMessages.length - 1) {
    const { frontendId, index: glIndex } = visibleMessages[index + 1];
    return () => setActiveMessageDetailsState({ frontendId, glIndex });
  }
  return void 0;
};
const _prevMessageDetails = (visibleMessages, setActiveMessageDetailsState, activeMessageDetailsState) => {
  const index = visibleMessages.findIndex(findMessageCallback(activeMessageDetailsState));
  if (index > 0) {
    const { frontendId, index: glIndex } = visibleMessages[index - 1];
    return () => setActiveMessageDetailsState({ frontendId, glIndex });
  }
  return void 0;
};
const MessageDetailsProvider = ({ children }) => {
  const { pages } = useContext(ListStateContext);
  const [activeMessageDetailsState, setActiveMessageDetailsState] = useState(null);
  const contextValue = useMemo(() => {
    const visibleMessages = pages.flatMap(([, messages]) => messages).toJS();
    const activeMessageDetails = activeMessageDetailsState && visibleMessages.find(findMessageCallback(activeMessageDetailsState));
    const onSelectNextMessage = _nextMessageDetails(
      visibleMessages,
      setActiveMessageDetailsState,
      activeMessageDetailsState
    );
    const onSelectPreviousMessage = _prevMessageDetails(
      visibleMessages,
      setActiveMessageDetailsState,
      activeMessageDetailsState
    );
    return {
      activeMessageDetails,
      selectNextMessage: onSelectNextMessage,
      selectPrevMessage: onSelectPreviousMessage,
      setActiveMessageDetailsState
    };
  }, [activeMessageDetailsState, pages]);
  return /* @__PURE__ */ React.createElement(MessageDetailsContext.Provider, { value: contextValue }, children);
};
export default MessageDetailsProvider;
